<div class='error-page' fxLayout='row' fxLayoutAlign='space-between start'>
    <div class='page-text' fxLayout='column' fxLayoutGap='16px'>
  
      <div class='error-header'>
        {{'NO_PERMISSION_MSG' | translate}}
      </div>
  
    </div>
</div>
  